import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../cf";

export const SUBSCRIPTION_QUERY_KEY = ["subscription"] as const;

export const useSubscriptionQuery = (workspaceId: string) => {
  return useQuery({
    queryKey: [...SUBSCRIPTION_QUERY_KEY, workspaceId],
    queryFn: async () => {
      const res = await apiClient.user.subscription[":workspaceId"].$get({
        param: { workspaceId },
      });
      if (!res.ok) {
        throw new Error("Failed to fetch subscription");
      }
      return res.json();
    },
    enabled: workspaceId !== "",
  });
};
